import React from "react";
import "./App.css";

import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./pages/home1";
import Services from "./pages/services";
import Projects from "./pages/projects";
import WebAndMobileApplication from "./pages/projects/webAndMobileAppDevlopment"; //  web and mobile app devopent
import DigitalMarketing from "./pages/projects/DigitalMarketing"; //digital marketing
import Process from "./pages/process";
import Technology from "./pages/technologys";
import Talkus from "./pages/talk2us";
import Appointment from "./pages/appointment";
import Quote from "./pages/freequote";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CaseStudyPages from "./pages/casestudy/index";
import KumarPhotography from "./pages/casestudy/websites/KumarPhotography";
import AJTechIndustry from "./pages/casestudy/websites/AJTechIndustry";
import GenuineITSystems from "./pages/casestudy/websites/GenuineITSystems";
import Gnanodhaya from "./pages/casestudy/websites/Gnanodhaya";
import AssetGlances from "./pages/casestudy/websites/AssetGlance";
import Hostecwebsite from "./pages/casestudy/websites/Hostec";
import DevangiAtithyaweb from "./pages/casestudy/websites/DevangiAtithya";
import AmberAroma from "./pages/casestudy/websites/AmberAroma";
import Zeeqr from "./pages/casestudy/websites/Zeeqr";
import ScentaBook from "./pages/casestudy/websites/ScentaBook";
import KudlaBuilders from "./pages/casestudy/websites/KudlaBuilders";
import AryaFireandSafety from "./pages/casestudy/websites/AryaFireAndSafety";
import HilightLightingStudio from "./pages/casestudy/websites/HilightLightingStudio";
import ScienceBlue from "./pages/casestudy/websites/ScienceBlue";
import SNKollajeJewellers from "./pages/casestudy/websites/SNKollajeJewellers";
import BuildALead from "./pages/casestudy/websites/BuildALead";
import RaajPowerElectricals from "./pages/casestudy/websites/RaajPowerElectricals";

import Socialmediamarketing from "./pages/home1/services/Additionalpages/socialmediamarketing";
import PerformanceMarketing from "./pages/home1/services/Additionalpages/performancemarketing";
import Webandmobileapplication from "./pages/home1/services/Additionalpages/webandmobileapplication";
import Photography360view from "./pages/home1/services/Additionalpages/360viewphotography";
import Branding from "./pages/home1/services/Additionalpages/branding";
import Itsolution from "./pages/home1/services/Additionalpages/itsolution";
import Seo from "./pages/home1/services/Additionalpages/seo";
function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route
          path="/projects/webandmobileapplication"
          element={<WebAndMobileApplication />}
        />
        <Route
          path="/projects/digitalmarketing"
          element={<DigitalMarketing />}
        />

        <Route path="/process" element={<Process />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/talk_us" element={<Talkus />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/free_quote" element={<Quote />} />
        {/* <Route path='/case-study' element={<CaseStudy />} /> */}
        <Route path="/kumarphotography" element={<KumarPhotography />} />
        <Route path="/ajtechIndustry" element={<AJTechIndustry />} />
        <Route path="/genuineitsystems" element={<GenuineITSystems />} />
        <Route path="/gnanodhaya" element={<Gnanodhaya />} />
        <Route path="/assetglance" element={<AssetGlances />} />
        <Route path="/hostec" element={<Hostecwebsite />} />
        <Route path="/devangiAtithya" element={<DevangiAtithyaweb />} />
        <Route path="/amber-aroma" element={<AmberAroma />} />
        <Route path="/zeeqr" element={<Zeeqr />} />
        <Route path="/scenta-book" element={<ScentaBook />} />
        <Route path="/kudla-builders" element={<KudlaBuilders />} />
        <Route path="/aryafire-and-safety" element={<AryaFireandSafety />} />
        {/* <Route
          path="/aryafire-and-safety"
          element={<HilightLightingStudio />}
        /> */}

        <Route
          path="/hilight-lighting-studio"
          element={<HilightLightingStudio />}
        />
        <Route path="/science-blue" element={<ScienceBlue />} />
        <Route path="/sn-kollaje-jewellers" element={<SNKollajeJewellers />} />
        <Route path="/build-a-lead" element={<BuildALead />} />
        <Route
          path="/raaj-power-electricals"
          element={<RaajPowerElectricals />}
        />

        <Route
          path="/socialmediamarketing"
          element={<Socialmediamarketing />}
        />
        <Route
          path="/performanceMarketing"
          element={<PerformanceMarketing />}
        />
        <Route
          path="/webandmobileapplication"
          element={<Webandmobileapplication />}
        />
        <Route path="/photography360view" element={<Photography360view />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/seo" element={<Seo />} />
        <Route path="/itsolution" element={<Itsolution />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
